import type { CSSProperties, ReactNode } from 'react'

import { AUTH_FLOATING_ICON_LIST } from './auth-floating-icons.const'

export const AuthFloatingIcons = (): ReactNode => (
  <div className="auth-floating-icons pointer-events-none absolute inset-0 hidden overflow-hidden lg:block">
    {AUTH_FLOATING_ICON_LIST.map((icon) => (
      <div
        key={icon.alt}
        className="absolute flex items-center justify-center transition-transform duration-500 ease-out"
        style={
          {
            top: icon.top,
            left: icon.left,
            width: icon.size,
            height: icon.size,
            opacity: icon.opacity ?? 1,
            transform: `translate(calc(var(--mouse-x, 0) * ${String(icon.parallaxFactor)}px), calc(var(--mouse-y, 0) * ${String(icon.parallaxFactor)}px))`,
          } as CSSProperties
        }
      >
        <img
          src={icon.src}
          alt=""
          aria-hidden="true"
          className="h-full w-full object-contain brightness-0 invert"
        />
      </div>
    ))}
  </div>
)
